<div class="filtercontainer row">
    <div style="width: 100%;">
        <div class="heading">My Files</div>
        <div class="input-group-sm mt-1 input-group col-6" style="vertical-align: middle;">
            <input class="form-control" type="search" [(ngModel)]="userfilterInput"
                (keyup)="applyUserFilter()" (search)="applyUserFilter()" placeholder="Filter">
        </div>
        <div >        
            <table aria-describedby="report-table" mat-table [dataSource]="userReportList" matSort>

                <ng-container matColumnDef="Users">
                    <th id="Users" mat-header-cell *matHeaderCellDef mat-sort-header> Users </th>
                    <td mat-cell style="text-align:left;" *matCellDef="let element">
                        {{element.name}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="upload">
                    <th id="upload" mat-header-cell *matHeaderCellDef mat-sort-header> # of documents uploaded  </th>
                    <td mat-cell *matCellDef="let element"> {{element.UPLOADED }} </td>
                </ng-container>
                <ng-container matColumnDef="index">
                    <th id="index" mat-header-cell *matHeaderCellDef mat-sort-header> # of documents indexed </th>
                    <td mat-cell *matCellDef="let element"> {{element.INDEXED }} </td>
                </ng-container>
                <ng-container matColumnDef="duplicate">
                    <th id="duplicate" mat-header-cell *matHeaderCellDef mat-sort-header> # of documents identified as duplicates </th>
                    <td mat-cell *matCellDef="let element"> {{element.DUPLICATE}} </td>
                </ng-container>
                <ng-container matColumnDef="export">
                    <th id="export" mat-header-cell *matHeaderCellDef mat-sort-header> # of documents exported to ECM </th>
                    <td mat-cell *matCellDef="let element"> {{element.EXPORTED}} </td>
                </ng-container>
                

                <tr mat-header-row *matHeaderRowDef="userCols"></tr>
                <!-- <tr mat-row *matRowDef="let row; columns: documentCols;" class="element-row">
                </tr> -->
                <tr mat-row *matRowDef="let row; columns: userCols;"
                    class="element-row" [class.selected-row]="selectedRow === row"
                    (click)="selectedRow = selectedRow === row ? null : row"
                    title="user">
                </tr>
            </table>
            <mat-paginator #userPaginator [pageSizeOptions]="[5,10, 20, 50]" [pageSize]="10" showFirstLastButtons>
            </mat-paginator>
            <div *ngIf="loadNext" class="loadButton">
                <button mat-raised-button (click)=next()>Next 200<mat-icon>keyboard_arrow_right
                    </mat-icon></button>
            </div>
            <div *ngIf="loadPrevious" class="loadButton">
                <button mat-raised-button (click)=previous()>
                    <mat-icon>keyboard_arrow_left</mat-icon>Previous 200
                </button>
            </div>
        </div>
    </div>
    <div style="width: 100%;">
        <div class="heading">Team Files</div>
        <div class="input-group-sm mt-1 input-group col-6" style="vertical-align: middle;">
            <input class="form-control" type="search" [(ngModel)]="teamfilterInput"
                (keyup)="applyTeamFilter()" (search)="applyTeamFilter()" placeholder="Filter">
        </div>
        <div >        
            <table aria-describedby="report-table" mat-table [dataSource]="teamReportList" matSort>

                <ng-container matColumnDef="Teams">
                    <th id="Teams" mat-header-cell *matHeaderCellDef mat-sort-header> Teams </th>
                    <td mat-cell style="text-align:left;" *matCellDef="let element">
                        {{element.team}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="upload">
                    <th id="upload" mat-header-cell *matHeaderCellDef mat-sort-header> # of documents uploaded  </th>
                    <td mat-cell *matCellDef="let element"> {{element.UPLOADED }} </td>
                </ng-container>
                <ng-container matColumnDef="index">
                    <th id="index" mat-header-cell *matHeaderCellDef mat-sort-header> # of documents indexed </th>
                    <td mat-cell *matCellDef="let element"> {{element.INDEXED }} </td>
                </ng-container>
                <ng-container matColumnDef="duplicate">
                    <th id="duplicate" mat-header-cell *matHeaderCellDef mat-sort-header> # of documents identified as duplicates </th>
                    <td mat-cell *matCellDef="let element"> {{element.DUPLICATE}} </td>
                </ng-container>
                <ng-container matColumnDef="export">
                    <th id="export" mat-header-cell *matHeaderCellDef mat-sort-header> # of documents exported to ECM </th>
                    <td mat-cell *matCellDef="let element"> {{element.EXPORTED}} </td>
                </ng-container>
                

                <tr mat-header-row *matHeaderRowDef="teamsCols"></tr>
                <!-- <tr mat-row *matRowDef="let row; columns: documentCols;" class="element-row">
                </tr> -->
                <tr mat-row *matRowDef="let row; columns: teamsCols;"
                    class="element-row" [class.selected-row]="selectedRow === row"
                    (click)="selectedRow = selectedRow === row ? null : row"
                    title="ream">
                </tr>
            </table>
            <mat-paginator #teamPaginator [pageSizeOptions]="[5,10, 20, 50]" [pageSize]="10" showFirstLastButtons>
            </mat-paginator>
            <div *ngIf="loadTeamNext" class="loadButton">
                <button mat-raised-button (click)="teamNext()">Next 200<mat-icon>keyboard_arrow_right
                    </mat-icon></button>
            </div>
            <div *ngIf="loadTeamPrevious" class="loadButton">
                <button mat-raised-button (click)="teamPrevious()">
                    <mat-icon>keyboard_arrow_left</mat-icon>Previous 200
                </button>
            </div>
        </div>
    </div>
    
</div>